import { Controller } from 'stimulus'
import $ from 'jquery'
import dropdown from 'semantic-ui-dropdown'
import transition from 'semantic-ui-transition'

$.fn.dropdown = dropdown
$.fn.transition = transition

export default class extends Controller {
  static targets = ['select']

  connect() {
    this.cloneOptionsFromSource()

    $(this.selectTarget).dropdown({
      onAdd: this.onAdd,
    })
    this.createNestedOptions()
    this.onAdd()
  }

  // A view manda neste select apenas as categorias já selecionadas, e a lista
  // completa vive no select de categoria principal. Aqui as que faltam são
  // copiadas de lá, antes de o dropdown ser montado — assim a lista inteira não
  // precisa ir duas vezes no HTML.
  cloneOptionsFromSource() {
    const selector = this.data.get('source')
    if (!selector) return

    const source = document.querySelector(selector)
    if (!source) return

    const select = this.selectTarget
    const selected = new Set(Array.from(select.options).filter(o => o.selected).map(o => o.value))
    const fromSource = new Set(Array.from(source.options).map(o => o.value))
    // Defensivo: qualquer option que já esteja aqui e não exista na origem é
    // mantida, para não perder uma seleção que a origem não lista.
    const orphans = Array.from(select.options).filter(o => o.value && !fromSource.has(o.value))
    const fragment = document.createDocumentFragment()

    // Reconstrói na ordem da origem: as categorias vêm indentadas por
    // profundidade, e apenas concatenar as selecionadas no topo bagunçaria a
    // hierarquia que o operador vê no dropdown.
    Array.from(source.options).forEach(option => {
      if (!option.value) return

      const clone = document.createElement('option')
      clone.value = option.value
      clone.textContent = option.textContent
      clone.selected = selected.has(option.value)
      fragment.appendChild(clone)
    })

    orphans.forEach(option => fragment.appendChild(option))

    select.innerHTML = ''
    select.appendChild(fragment)
  }

  createNestedOptions() {
    const $options = $(this.selectTarget).siblings('.menu').find('.item')

    $options.each(this.formatOptions)
  }

  formatOptions(_, option) {
    const label = option.textContent.replace(/-(?!([A-Za-z])\w+)/g, `${String.fromCharCode(160)}${String.fromCharCode(160)}`)

    option.textContent = label
  }

  onAdd = () => {
    const $labels = $(this.selectTarget).siblings('.ui.label')

    $labels.each(this.formatLabel)
  }

  formatLabel(_, label) {
    const endOfLabelPos = label.innerHTML.search('<') // Position where the text of label ends
    const wordToReplace = label.innerHTML.substr(0, endOfLabelPos) // Label text without icon
    const formattedLabel = wordToReplace.replace(/(&nbsp;)|(^-*)/g, '', '').trim()
    const htmlToAppend = label.innerHTML.replace(wordToReplace, formattedLabel)

    label.innerHTML = htmlToAppend
  }
}
